import React from 'react'

interface LogIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const LogIcon: React.FC<LogIconProps> = ({
  color = '#000000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Log icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M2 1.25h14a.75.75 0 01.75.75v4.666l-2.517 2.709H4a.625.625 0 100 1.25h9.072L10 13.932v3.145h2.919l3.831-4.131V22a.75.75 0 01-.75.75H2a.75.75 0 01-.75-.75V2A.75.75 0 012 1.25zM18 2v3.32l.61-.656.852.918 2.06 2.219L18 11.598V22a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h14a2 2 0 012 2zM4 5.375a.625.625 0 100 1.25h10.018a.625.625 0 100-1.25H4zm0 8a.625.625 0 100 1.25h3.795a.625.625 0 100-1.25H4zm8.373 2.452L19.816 7.8l-1.207-1.3-7.359 7.922v1.404h1.123zM22.355 5.08l.264-.285-1.213-1.308-.265.286 1.214 1.307zm-1.498-2.838l-1.421 1.53L21.502 6l.853.919.852-.919.568-.612a.891.891 0 00-.007-1.192l-1.813-1.953a.742.742 0 00-1.098 0z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default LogIcon
